import { MaterialValue } from '../../AttributeValue';
import { AttributeValueInstance } from './AttributeValueInstance';

export class MaterialValueInstance extends AttributeValueInstance<MaterialValue> {
  constructor(attributeValue: MaterialValue) {
    super(attributeValue);
  }
}
